import React, { useState } from 'react'
import {makeStyles} from "@material-ui/core/styles";
import ResourceTile from "./ResourceTile";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const ResourceRow = (props) => {
  const css = useStyles();

  if (!props.resourceItems || props.resourceItems.length < 1){
    return (
      <div className={css.rowContainer}>
        <div>
          <h3>{props.rowTitle}</h3>
          <span className={css.rowSubTitle}>(0 Total)</span>
        </div>
        <div className={css.rowResource}>
          No resources found.
        </div>
      </div>
    )
  }

  const cards = props.resourceItems.map((item, index) => <ResourceTile {...item} key={index} />);

  return (
    <div>
      <div className={`my-2 w-100 ${css.rowContainer}`}>
        <ExpansionPanel square expanded={props.expanded} className="resource-center-panel">
          <ExpansionPanelSummary
            expandIcon={<KeyboardArrowDownIcon />}
            aria-controls="panel1-content"
            className={'px-2'}
            onClick={() => props.handleChange()}
          >
            <h6 className="pl-2"><b>{props.title || props.rowTitle}</b></h6>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div>
              <div>
                <span className={css.rowSubTitle}>({cards.length} Total)</span>
              </div>
              <div className={css.rowResource}>
                {cards}
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  linkUser: {
    color: `${theme.palette.primary.main}`,
  },
  rowContainer: {
    paddingTop: 15
  },
  rowSubTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 3,
    textTransform: 'uppercase'
  },
  rowResource: {
    display: 'inline-flex',
    marginTop: '1em',
    marginBottom: '1em',
    flexWrap: 'wrap'
  }
}));

export default ResourceRow;


// WEBPACK FOOTER //
// ./src/components/Resource Center/SubComponents/ResourceRow.js